<template>
  <div/>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Appcues',
  props: {
    activate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('user', ['userId', 'domainInfo', 'interactiveGuidesOn', 'isEnterprise', 'isPremium', 'isTrial', 'isLicenseExpired', 'userContentProfileId']),
    ...mapGetters('goaldetail', ['getPMAs']),
  },
  watch: {
    activate(newVal) {
      if (newVal) {
        this.activateAppcues()
      }
    },
    getPMAs(newVal) {
      if (newVal.length) {
        this.triggerPMAFlow()
      }
    }
  },
  mounted() {
    if (this.activate) {
      this.activateAppcues()
    }
  },
  methods: {
    activateAppcues() {
      if (!document.querySelector('#appcues-script-tag')) {
        window.AppcuesSettings = {
          enableURLDetection: true
        };
        let appcuesScript = document.createElement('script');
        appcuesScript.id = 'appcues-script-tag'
        appcuesScript.setAttribute('src','//fast.appcues.com/128659.js');
        appcuesScript.onload = () => {
          Appcues.identify(this.userId, {
            domain_uuid: this.domainInfo.uuid,
            domain_name: this.domainInfo.name,
            isEnterprise: this.isEnterprise,
            isPremium: this.isPremium,
            isTrial: this.isTrial,
            isLicenseExpired: this.isLicenseExpired,
            userContentProfileId: this.userContentProfileId
          })
        }
        document.head.appendChild(appcuesScript);
      } else {
        Appcues.page(this.userId, {
            domain_uuid: this.domainInfo.uuid,
            domain_name: this.domainInfo.name,
            isEnterprise: this.isEnterprise,
            isPremium: this.isPremium,
            isTrial: this.isTrial,
            isLicenseExpired: this.isLicenseExpired,
            userContentProfileId: this.userContentProfileId
          })
      }
    },

    triggerPMAFlow() {
      if (this.interactiveGuidesOn) {
        if (location.href.indexOf('pma=') === -1) {
          if (location.href.indexOf('?') > -1) {
            history.replaceState({}, '', location.href + '&pma=1')
          } else {
            history.replaceState({}, '', location.href + '?pma=1')
          }
        }
      }
    }
  }
}
</script>
